import { render, staticRenderFns } from "./ShareInNetwork.vue?vue&type=template&id=f50b272c&"
import script from "./ShareInNetwork.vue?vue&type=script&lang=js&"
export * from "./ShareInNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports